import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=0ef193fb&scoped=true&lang=html&"
import script from "./Campaign.vue?vue&type=script&lang=js&"
export * from "./Campaign.vue?vue&type=script&lang=js&"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=0ef193fb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef193fb",
  null
  
)

export default component.exports